export default {
    name: "",
    props: [
        "target",
        "dragTargetSelf",
        "dragTarget",
        "dragContainer",
        "container",
        "warpSelf",
        "rootContainer",
        "useResizeObserver",
        "useMutationObserver",
        "zoom",
        "dragFocusedInput",
        "transformOrigin",
        "ables",
        "className",
        "pinchThreshold",
        "pinchOutside",
        "triggerAblesSimultaneously",
        "checkInput",
        "cspNonce",
        "translateZ",
        "hideDefaultLines",
        "props",
        "flushSync",
        "stopPropagation",
        "preventClickEventOnDrag",
        "preventClickDefault",
        "viewContainer",
        "persistData",
        "useAccuratePosition",
        "firstRenderState",
        "linePadding",
        "controlPadding",
        "preventDefault",
        "preventRightClick",
        "preventWheelClick",
        "requestStyles",
    ] as const,
    events: [
        "changeTargets",
    ] as const,
};
